import axios, { AxiosRequestConfig } from "axios";

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development" ? "http://localhost:3000" : "",
});

instance.interceptors.request.use((config: any) => {
  const token = getToken();

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

// ✅ Add this: Automatically logout on 401
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear token on 401 (e.g., session expired / logged in elsewhere)
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("remember_me");

      // Optionally: show a message or toast here

      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

function getToken() {
  const isPersist = localStorage.getItem("remember_me");

  if (isPersist === "true") {
    return localStorage.getItem("token");
  } else {
    return sessionStorage.getItem("token");
  }
}

export default instance;
